export default {"src":"/_next/static/media/BuckBoost.af59f4df.svg","height":340,"width":810,"blurWidth":0,"blurHeight":0};